import { flatten } from "lodash";

const escapeDiacritics = text =>
  text
    .replace(/ą/g, "a")
    .replace(/Ą/g, "A")
    .replace(/ć/g, "c")
    .replace(/Ć/g, "C")
    .replace(/ę/g, "e")
    .replace(/Ę/g, "E")
    .replace(/ł/g, "l")
    .replace(/Ł/g, "L")
    .replace(/ń/g, "n")
    .replace(/Ń/g, "N")
    .replace(/ó/g, "o")
    .replace(/Ó/g, "O")
    .replace(/ś/g, "s")
    .replace(/Ś/g, "S")
    .replace(/ż/g, "z")
    .replace(/Ż/g, "Z")
    .replace(/ź/g, "z")
    .replace(/Ź/g, "Z");

export const slugify = text =>
  escapeDiacritics(text.toString())
    .toLowerCase()
    .trim()
    .replace(/\s+/g, "-") // Replace spaces with -
    .replace(/&/g, "-and-") // Replace & with 'and'
    .replace(/[^\w\-]+/g, "") // Remove all non-word chars
    .replace(/\-\-+/g, "-"); // Replace multiple - with single -

const getCategoryById = (categories, categoryId: string) =>
  categories.find(({ id }) => id === categoryId);

const getCategorySlugWithParentCategories = (categories, categoryId, slug) => {
  const { name, parent } = getCategoryById(categories, categoryId);
  const newSlug = `${slugify(name)}/${slug}`;
  return parent
    ? getCategorySlugWithParentCategories(categories, parent.id, newSlug)
    : newSlug;
};

export const generatePageUrl = (slug: string) => `/${slug}/`;
export const generatePostUrl = (slug: string, catSlug: string, parentCatSlug?: string) => `${parentCatSlug ? `/${parentCatSlug}` : ''}${catSlug ? `/${catSlug}` : ''}/${slug}/`;

export const preparePostUrl = ({ slug, categories: { nodes: [firstCategory] } }): string =>
  generatePostUrl(slug, firstCategory?.slug, firstCategory?.parent?.node?.slug);

export const maybe = <T>(exp: () => T, d?: T) => {
  try {
    const result = exp();
    return result === undefined ? d : result;
  } catch {
    return d;
  }
};

export const getDescendants = (id, array) => {
  const children = array
    .filter(item => item.parent && item.parent.id === id)
    .map(({ id }) => id);
  if (!children.length) return [];
  return [
    ...children,
    ...flatten(children.map(({ id }) => getDescendants(id, array))),
  ];
};
